import { type FC } from 'react'
import { Button } from 'shared/ui'
import { type Contact } from 'entities/Contacts/model/Contact'

type IEmailActionProps = {
  contact: Contact
  disabled: boolean
  className?: string
}

export const EmailAction: FC<IEmailActionProps> = ({ contact, disabled, className }) => {
  return (
    <a href={contact.email ? `mailto:${contact.email}` : '#'}>
      <Button
        size='medium'
        typeBtn='contained'
        contained='secondary'
        icon='email'
        iconProps={{
          color:
            disabled || !contact.email
              ? 'var(--content-neutral-primary)'
              : 'var(--content-primary-tertiary)',
        }}
        paddingInline={11}
        text='Email'
        className={className}
        disabled={disabled || !contact.email}
        tooltipProps={
          !contact.email
            ? {
                label: 'Add an email address to enable email sending.',
                placement: 'bottom',
                width: 169,
              }
            : undefined
        }
      />
    </a>
  )
}
